import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
export class ObSound extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      AnteNatalHistoryPreviousObstetricUltrasound: "",
      AnteNatalHistoryNumPreviousUltrasound: "",
      AnteNatalHistoryTableTrimester: "",
      AnteNatalHistoryTableDate: "",
      AnteNatalHistoryTableResult: "",
      myParentTrigger: "",
      patientName: localStorage.getItem("currentVisitName"),
      tablevaluesglobal: {},
      loading:false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
    this.modal = true;
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      // alert('hh')
    $(".hiddenPart").show();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
     
    });
  }

  proceedEvent(event) {
    window.location.href = "/preplan/analysis";
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };

    event.preventDefault();

    let PreviousObstetricUltrasound = event.target[0].value;
    let NumPreviousUltrasound = event.target[1].value;
    let finalpayload = {};
    finalpayload.PreviousObstetricUltrasound = PreviousObstetricUltrasound;
    finalpayload.NumPreviousUltrasound = NumPreviousUltrasound;
    finalpayload.ultrasound = this.state.tablevaluesglobal.ultrasound;
    // console.log(finalpayload);
    this.setState({
      loading:  true
    })
    axios
      .post(
        this.api_url+""+localStorage.getItem('currentModule')+"/obstetricultrasound/main",
        finalpayload,
        { headers: headers }
      )
      .then((response) => {
        console.log(response);
        this.setState({
          loading:  false
        })
       
              console.log(response);
              // let table = response.data;
              // console.log(table);
              // let object = {};
              // for (let i = 0; i < table.length; i++) {
              //   delete table[i]._id;
              //   delete table[i].timeOfRegistration;
              //   table[i].clickEvent = () => this.handleRowClick(table[i]);
              // }
              // table = JSON.stringify(table);
              // this.TableData = table;
              // console.log(this.TableData);
              // this.setState({
              //   DataLoaded: true,
              // });
          
        
            $(".alert-success").show();
            setTimeout(function () {
              // alert('sdsd')
              window.location.href = "/preplan/analysis";
              // $('.HistoryModal').show()
            }, 1500);
          
        // }
      })
      .catch((error) => {
        $("#SubmitSuccess").hide();
        $("#SubmitError").show();
        console.log(error);
        this.setState({
          loading:  false
        })
      });
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  formatTableOutput(data) {
    console.log("data");
    console.log(data);
    let topobj = {}; //empty final obj
    let tableobj = {}; //empty obj
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {}; //local scope empty obj
      trimobj.date = data[i][1];
      trimobj.result = data[i][2];
      tableobj["trimester" + [i + 1]] = trimobj; //create dynamic keys i.e trimester1,trimester2
      topobj.ultrasound = tableobj;
    }
    this.state.tablevaluesglobal = topobj;
  }

  getTableValues(event) {
    // console.log('entns');
    // console.log(event);
    let tablevalues = this.formatTableOutput(event);
    console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["1st", "", ""],
      ["2nd", "", ""],
      ["3rd", "", ""],
      // ["4th", "", ""],
    ];
    const columns = ["Trimester", "Date", "Result"];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };
    // {""1st":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      AttendedAntenatalCare,
      NumPreviousVisits,
      FaciltyPreviousVisits,
      AntiTetanusVaccination,
      NumPreviousVaccinations,
      LastVaccinationDate,
      AnteNatalHistoryPreviousObstetricUltrasound,
      AnteNatalHistoryNumPreviousUltrasound,
      AnteNatalHistoryTableTrimester,
      AnteNatalHistoryTableDate,
      PreviousFacilityVisitDate,
      AnteNatalHistoryTableResult,
      patientName,
      loading
    } = this.state;

    let { DataLoaded } = this.state;
    const tabledata = {
      columns: [
        {
          label: "Trimester Date 1",
          field: " trimester1date",
          sort: "asc",
          width: 50,
        },
        {
          label: "Trimester Result 1",
          field: "trimester1result",
          sort: "asc",
          width: 50,
        },
        {
          label: "Trimester Date 2",
          field: "trimester2date",
          sort: "asc",
          width: 50,
        },
        {
          label: "Trimester Result 2",
          field: "trimester2result",
          sort: "asc",
          width: 50,
        },
        {
          label: "Trimester Date 3",
          field: "trimester3date",
          sort: "asc",
          width: 50,
        },
        {
          label: "Trimester Result 3",
          field: "trimester3result",
          sort: "asc",
          width: 50,
        },
        {
          label: "Date",
          field: "NumPreviousUltrasound",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers />
        <TriageSidebar />
        <main className="content-container ">
          <div className="container p-2">
            <form id="obsform" onSubmit={this.handleSubmit}>
              <div className="col-md-6 p-2">
                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Has OB/Ultrasound ever been achieved?
                  </h6>
                  <select
                    onChange={this.handleChange}
                    value={AnteNatalHistoryPreviousObstetricUltrasound}
                    name="AnteNatalHistoryPreviousObstetricUltrasound"
                    className="form-control"
                    required
                  >
                    <optgroup label="">
                      <option selected disabled></option>
                      <option className="yesSelected" value="yes">
                        Yes
                      </option>
                      <option className="noSelected" value="no">
                        No
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>
              {/* <div className="col-md-6 p-2"> */}
              <div className="hiddenPart" style={displayHidden}>
                <div className="py-1">
                  <h6 className="text-capitalize" style={fontFamilyNunito}>
                    Date
                  </h6>
                  <input
                    onChange={this.handleChange}
                    value={AnteNatalHistoryNumPreviousUltrasound}
                    name="AnteNatalHistoryNumPreviousUltrasound"
                    className="form-control"
                    type="date"
                  />
                </div>

                <MDBCard>
                  <MDBCardHeader
                    tag="h3"
                    className="text-center font-weight-bold text-capitalise py-4"
                  >
                    Obstetrics UltraSound
                  </MDBCardHeader>
                  <MDBCardBody>
                    <MDBTableEditable
                      onChange={(value) => this.handleTableChange(value)}
                      getValue={(value) => this.getTableValues(value)}
                      myParentTrigger={this.state.myParentTrigger}
                      id="editablecard"
                      data={data}
                      columns={columns}
                      striped
                      bordered
                    />
                  </MDBCardBody>
                </MDBCard>
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
          
             
                  <input
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    value={loading ? 'Loading' : 'Submit'} 
                    style={floatLeft}
                  />
                  
                   
                
                {/* </div> */}
            
        
            </form>
          
          
            
          </div>
        </main>
      </div>
    );
  }
}

export default ObSound;
